var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"max-w-5xl mx-auto space-y-16"},[_c('AdListComponent',{attrs:{"fetching":_vm.fetching,"ads":_vm.ads,"meta":_vm.meta},on:{"get-ads":_vm.handleGetAds}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }